// extracted by mini-css-extract-plugin
export default {"our-numbers-grid-card":"styles_our-numbers-grid-card__e2XwC"};